<template>
    <div>
        <FormLabel :value="$tc('messages.answers', 1)" />
        <FormInput
            required
            :id="$tc('messages.answers', 1)"
            v-model.trim="form.answer"
            type="text"
            maxlength="191"
            class="mt-1 w-full"
        />
        <FormError :value="errors[`options.answer`]" class="mt-2" />
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'QuestionOrderPhraseOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
